<template>
  <van-popup
    v-model:show="currentVisible"
    position="bottom"
    :style="{
      height: isCn ? '210px' : '285px',
      background: 'initial',
      display: 'flex',
      flexDirection: 'column',
    }"
    :close-on-popstate="true"
    round
    :lock-scroll="true"
    safe-area-inset-top
    safe-area-inset-bottom
    :lazy-render="false"
    teleport="body"
  >
    <div class="jcvf-popup-content">
      <div class="jcvf-popup-content-title">
        <JcImg :level="1"
          :src="$jcvfTag"
          class="shrink-0 inline-block pb-1 w-[77px] object-contain"
        />
        <span
          v-if="!isCn"
          class="ml-2 text-[#BA652F] text-[15px] font-popSB font-semibold"
          >by</span
        >
        <img :src="logo_sgs" alt="" class="h-[23px]" />
        <img
          :src="icon_close_popup_jcvf"
          alt="close"
          class="size-6 ml-auto"
          @click="currentVisible = false"
        />
      </div>
      <div class="jcvf-popup-content-desc">
        <p
          class="text-paper-200 text-[14px] break-words whitespace-pre-line leading-5"
        >
          {{
            isCn
              ? `该公司提交的经营能力证明材料通过了SGS核验，审核时间${$dayjs(jcvfTime).locale('zh-CN').format('YYYY-MM-D')}，相关能力标签和核验报告可以在店铺详情查看。`
              : `The business operation capability proof materials submitted by the company have passed the SGS verification.\n\n The verification time was ${$dayjs(jcvfTime).locale('en-US').format('MMM D , YYYY')}.\n\n The relevant capability labels and verification reports can be viewed in the store details.`
          }}
        </p>
        <div
          class="text-[#BA652F] font-popSB text-sm mt-4 flex items-center"
          @click="() => navigateTo({ name: 'membershipJCVF' })"
        >
          {{ $t('homeIndex.viewmore') }}
          <img :src="icon_more_slope_jcvf" alt="" class="size-4" />
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script lang="ts" setup>
  import icon_close_popup_jcvf from '@/assets/images/jcvf/popup/icon_close_popup_jcvf@2x.png'
  import icon_more_slope_jcvf from '@/assets/images/jcvf/popup/icon_more_slope_jcvf@2x.png'
  import logo_sgs from '@/assets/images/jcvf/logo_sgs.png'
  import { popupProps } from 'vant'
  const currentVisible = defineModel('visible', {
    type: Boolean,
  })

  const { isCn } = useVipLogo()
  const props = defineProps(
    Object.assign({}, popupProps, {
      jcvfTime: {
        type: String,
        default: () => '',
      },
    }),
  )
</script>

<style lang="scss" scoped>
  .jcvf-popup-content {
    position: relative;
    display: flex;
    // height: 100%;
    flex: 1;
    flex-direction: column;
    padding: 0;
    margin: 0;
    background: linear-gradient(270deg, #dc9b62 0%, #ba652f 100%);

    .jcvf-popup-content-title {
      position: sticky;
      top: 0;
      left: 0;
      min-width: 375px;
      height: 73px;
      margin: 0;
      overflow: hidden;
      font-family: Poppins-Bold, Poppins;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      color: #fff;
      // background: linear-gradient(90deg, #3a190b 0%, rgb(58 25 11 / 0) 100%);
      background: linear-gradient(270deg, #dc9b62 0%, #ba652f 100%);
      background-image: url('@/assets/images/jcvf/popup/bg_popup_jcvf@2x.png');
      background-repeat: no-repeat;
      background-size: 100% 73px;
      border: none;
      border-radius: 16px 16px 0 0;

      @apply flex justify-start items-center px-4;
    }

    .jcvf-popup-content-desc {
      margin-top: -16px;
      background: #fff;
      border-radius: 16px 0 0;

      @apply flex-1 p-4 relative;
    }
  }
</style>
